import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useConfirm } from 'material-ui-confirm';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import secureLocalStorage  from  "react-secure-storage";

// material
import { styled } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar, Button } from '@mui/material';

// GRAPHQL
import { useMutation } from '@apollo/client';
import { LoginGQLFunction } from '../../graphql/LOGIN';
// hooks
import useResponsive from '../../hooks/useResponsive';
import { useTranslation } from 'react-i18next';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import Iconify from '../../components/Iconify';
//
import navConfig from './NavConfig';
// import AccountPopover from './AccountPopover';



const DRAWER_WIDTH = 280;

// ----------------------------------------------------------------------

Sidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function Sidebar({ isOpenSidebar, onCloseSidebar }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const [logout] = useMutation(LoginGQLFunction.LOGOUT);
  const isDesktop = useResponsive('up', 'lg');
  const ischatroom = pathname === '/chatroom';

  // close the sidebar when page changed
  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  const navigate = useNavigate();

  // get the JSON string from sessionStorage
  const adminInfoStr = localStorage.getItem('admin-info');

  // convert JSON string to valid object
  const adminInfo = JSON.parse(adminInfoStr);

  const confirm = useConfirm();

  const renderContent = adminInfo?(
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}>
      <Box sx={{ px: 2, py: 3 }}>
        <Logo />
        {/* <AccountPopover /> */}
      </Box>
      
      <Box sx={{ mb: 2, mx: 2.5 }}>
        <Typography variant="subtitle1" sx={{ color: 'text.primary', ml: 1 }}>
          {adminInfo.cn}
        </Typography>

        <Link underline="none" component={RouterLink} to={`/admin/info/${adminInfo.adminId}`}>
          <div className="sidebar-account">
            <Avatar src={adminInfo.photoURL} alt="photoURL" />
            <Typography variant="subtitle2" sx={{ color: 'text.primary', ml: 2 }}>
              {adminInfo.displayName}
            </Typography>
          </div>
        </Link>
      </Box>

      <NavSection navConfig={navConfig} />

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ px: 0, pb: 0, mt: 0 }}>
        <Button
          variant="text"
          fullWidth
          startIcon={<Iconify icon="eva:log-out-fill" sx={{ width: 24, height: 24 }} />}
          color="error"
          onClick={() => {
            confirm({
              title: t('logout.confirm_title'),
              confirmationText: t('logout.confirm_text'),
              cancellationText: t('common.cancel'),
              confirmationButtonProps: { color: 'error' },
            })
              .then(async () => {
                localStorage.removeItem('admin-info');
                // console.log(await (await logout()).data.logout);
                const { data } = await logout({
                  variables: {
                    token: secureLocalStorage.getItem('token')
                  },
                  // fetchPolicy: 'no-cache',
                  fetchPolicy: 'network-only',
                });
                console.log(`logout response: ${JSON.stringify(data)}`);
                secureLocalStorage.removeItem('token');
                navigate('/login');
                // window.location.reload();
              })
              .catch(e => {
                console.log(`Logout cancelled: ${JSON.stringify(e)}`);
              });
          }}>{t('logout.button')}</Button>
      </Box>
    </Scrollbar>
  ) : null;

  return (
    <div className={`sidebar-root ${ischatroom ? 'sidebar--chatroom' : ''}`}>
      {!isDesktop || ischatroom ? (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}>
          {renderContent}
        </Drawer>
      )}
    </div>
  );
}
